import { render } from "./Claim.vue?vue&type=template&id=1ab3c948&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=1ab3c948&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab3c948"]])

export default __exports__